export default __webpack_public_path__ + "f1db436ed4456803bc2b9d4d5cf83563.svg";